import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environmet';
import { ChangePasswordRequest, ChangePasswordResponse, LoginApiResponse, LoginRequest } from '../../../../core/models/session.models';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = environment.apiBaseUrl;

  login(payload: LoginRequest): Observable<LoginApiResponse> {
    return this.http.post<LoginApiResponse>(`${this.baseUrl}/auth/login`, payload);
  }

  changePassword(payload: ChangePasswordRequest): Observable<ChangePasswordResponse> {
    return this.http.post<ChangePasswordResponse>(`${this.baseUrl}/auth/change-password`, payload);
  }
}